import { UploadBatch } from '../types';
import { apiFetch } from '../utilities/api';

interface BatchUpdatePayload {
  status: 'pending' | 'in_progress' | 'completed' | 'failed';
  error_details?: {
    type: string;
    message: string;
    duration?: number;
    failed_files?: Array<{
      file: string;
      error: string;
      error_type: string;
      size?: number;
      type?: string;
    }>;
    error_summary?: string;
  };
}

class UploadBatchService {
  private baseUrl = process.env.REACT_APP_API_ROOT;

  async createBatch(files: File[]): Promise<UploadBatch> {
    const totalSize = files.reduce((sum, file) => sum + file.size, 0);
    
    return apiFetch(`${this.baseUrl}api/v2/upload-batches/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        file_count: files.length,
        total_size: totalSize,
        service: 's3'
      })
    });
  }

  async getBatch(batchId: string | number): Promise<UploadBatch> {
    return apiFetch(`${this.baseUrl}api/v2/upload-batches/${batchId}/`);
  }

  async updateBatchStatus(batchId: string | number, status: BatchUpdatePayload['status'], details?: BatchUpdatePayload['error_details']): Promise<UploadBatch> {
    // If we have a UUID, we need to get the numeric ID first
    let numericId: number;
    if (typeof batchId === 'string') {
      const batch = await this.getBatch(batchId);
      numericId = batch.id;
    } else {
      numericId = batchId;
    }
    
    return apiFetch(`${this.baseUrl}api/v2/upload-batches/${numericId}/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        status,
        error_details: details
      })
    });
  }
}

export const uploadBatchService = new UploadBatchService();
